import React, { useState } from 'react';
import { observer } from 'mobx-react';
import CustomScroll from 'react-custom-scroll';
import { Box, Slide } from '@material-ui/core';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import defaultLocales from 'globals/locales/default';
import { NotificationType } from 'globals/types';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import SingleNotificationItem from 'ui-elements/boxes/FsNotificationFixedBox/SingleNotificationItem';
import FsIconButton from 'ui-elements/buttons/FsIconButton';
import {
  AbsoluteBox,
  BackdropBox,
  WrapperBox,
} from './FsNotificationFixedBox.style-elements';
import { paperStyle } from './FsNotificationFixedBox.style';
import NotificationSwitches from './NotificationSwitches';
import { ShowNotificationsProps } from './NotificationSwitches/NotificationSwitches';
import { SingleNotificationItemDataProps } from './SingleNotificationItem/SingleNotificationItem';

interface FsNotificationFixedBoxProps {
  show: boolean;
  onClose?: () => void;
  notifications: SingleNotificationItemDataProps[];
}

const FsNotificationFixedBox: React.FC<FsNotificationFixedBoxProps> = ({
  onClose,
  show,
  notifications,
}) => {
  const [
    showNotifications,
    setShowNotifications,
  ] = useState<ShowNotificationsProps>({
    [NotificationType.REPORTS]: true,
    [NotificationType.BANKS]: true,
    [NotificationType.OTHERS]: true,
  });

  const close = () => {
    if (onClose) onClose();
  };

  const updateShowNotificationsFlags = (key: NotificationType) => {
    setShowNotifications((currentValue) => ({
      ...currentValue,
      [key]: !currentValue[key],
    }));
  };

  const handleClose = async () => {
    close();
  };

  const buttons = [
    <FsIconButton key={0} onClick={close}>
      <CloseOutlinedIcon />
    </FsIconButton>,
  ];

  return (
    <>
      {show && <BackdropBox onClick={close} />}
      <Slide in={show} timeout={300} direction="left">
        <WrapperBox>
          <FsPaper
            title={defaultLocales.notifications}
            style={paperStyle}
            buttons={buttons}
          >
            <NotificationSwitches
              showNotifications={showNotifications}
              onSwitchesUpdate={updateShowNotificationsFlags}
            />
            <AbsoluteBox>
              <CustomScroll heightRelativeToParent="100%">
                <Box pr={2}>
                  {notifications.map(
                    ({ id, notificationType, ...otherProps }) =>
                      showNotifications[notificationType] && (
                        <SingleNotificationItem
                          {...{ ...otherProps, notificationType }}
                          key={id}
                          id={id}
                          onClick={() => handleClose()}
                          data-test="single-notification"
                        />
                      )
                  )}
                </Box>
              </CustomScroll>
            </AbsoluteBox>
          </FsPaper>
        </WrapperBox>
      </Slide>
    </>
  );
};

export default observer(FsNotificationFixedBox);
